import isType from './isType'

const isFunction = isType('Function')
export default isFunction
